import { render, staticRenderFns } from "./nav-left-stu.vue?vue&type=template&id=6ef722c0"
import script from "./nav-left-stu.vue?vue&type=script&lang=js"
export * from "./nav-left-stu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports